/* @ngInject */
export default class AccountsHistoryCtrl {
	constructor(
		$scope,
		$state,
		Utility,
		$timeout,
		$rootScope,
		BuildingsService,
		UserUnitsService,
		NotificationService,
		LocalStorageService,
		AccountsHistoryDataService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.BuildingsService = BuildingsService;
		this.UserUnitsService = UserUnitsService;
		this.NotificationService = NotificationService;
		this.LocalStorageService = LocalStorageService;
		this.AccountsHistoryDataService = AccountsHistoryDataService;

		this.init();
		this.activate();
	}

	init() {
		this.isBusy = false;
		this.unitList = [];
		this.isDetailsBusy = false;
		this.selectedCardCode = null;
		this.hasSelectedCardCode = false;
		this.selectedBuildingRef = undefined;
		this.dateTo = moment().format('YYYY/MM/DD');
		this.dateFrom = moment().subtract(6, 'months').format('YYYY/MM/DD');

		this.$scope.$on('selected-building-changed', (event, newValue) => {
			this.onSelectedBuildingChanged(event, newValue);
		});
	}

	async activate() {
		const { cardCode } = this.$state.params;
		this.accountsHistoryService = this.AccountsHistoryDataService;
		this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
		if (cardCode) {
			this.unitList = [ ...this.unitList, { CardCode: cardCode } ];
			this.getAccountsHistorySummary();
		}
		await this.getUnits();
	}

	async onSelectedBuildingChanged(event, schemeRef) {
		this._switchIsBusy(true);
		this.selectedBuildingRef = schemeRef;
		if (this.selectedBuildingRef && this.selectedBuildingRef.length > 2) {
			this._switchIsBusy(true);
			await this.getUnits();
		}
	}

	async getUnits() {
		this.selectedCardCode = null;
		this.hasSelectedCardCode = false;
		this.isDetailsBusy = false;
		this.dateFrom = moment().subtract(12, 'months').format('YYYY/MM/DD');
		this.dateTo = moment().format('YYYY/MM/DD');

		this.unitList = await this.UserUnitsService.getFriendlyUnitNames();
		if (this.unitList && this.unitList.length > 0) {
			this.getAccountsHistorySummary();
		}
	}

	viewDetails(cardCode) {
		this.selectedCardCode = cardCode;
		if (this.selectedCardCode) {
			this.hasSelectedCardCode = true;
			this.getAccountsHistory();
		}
	}

	searchAccountsHistory() {
		if (this.selectedCardCode && this.dateFrom && this.dateTo && this.dateFrom < this.dateTo) {
			this.getAccountsHistory();
		}
	}

	async getAccountsHistorySummary() {
		this._switchIsBusy(true);
		try {
			await this.AccountsHistoryDataService.getAccountsHistorySummary(
				this.selectedBuildingRef,
				this.unitList.filter(((unit) => {
					return !unit.CardCode.includes('9999');
				  }))
			);
			this.isBusy = false;
		} catch (err) {
			this.NotificationService.error('COULD NOT LOAD ACCOUNTS HISTORY SUMMARY');
			console.error(err);
		} finally {
			this._switchIsBusy(false);
		}
	}

	async getAccountsHistory() {
		this._switchIsDetailsBusy(true);
		try {
			await this.AccountsHistoryDataService.getAccountsHistory(this.selectedCardCode, this.dateFrom, this.dateTo);
		} catch (err) {
			this.NotificationService.error('COULD NOT LOAD ACCOUNTS HISTORY');
			console.error(err);
		} finally {
			this._switchIsDetailsBusy(false);
			this._initializeDatePicker();
		}
	}

	_initializeDatePicker() {
		const dateFrom = this.dateFrom;
		const dateTo = this.dateTo;

		this.$rootScope.$eval(() => {
			this.$timeout(() => {
				const id = '#accountsHistoryDates';
				const selectorDateFrom = '#dateFromDatePicker';
				const selectorDateTo = '#dateToDatePicker';
				const $inputDateFrom = $(selectorDateFrom, $(id));
				const $inputDateTo = $(selectorDateTo, $(id));

				const optionsDateFrom = {
					dateFrom,
					autoclose: true,
					forceParse: true,
					format: 'yyyy/mm/dd',
					assumeNearbyYear: true,
					enableOnReadonly: true,
					container: selectorDateFrom
				};

				const optionsDateTo = {
					dateTo,
					autoclose: true,
					forceParse: true,
					format: 'yyyy/mm/dd',
					assumeNearbyYear: true,
					enableOnReadonly: true,
					container: selectorDateTo
				};

				$inputDateFrom.datepicker(optionsDateFrom);
				$inputDateTo.datepicker(optionsDateTo);
			}, 250);
		});
	}

	async viewReport() {
		this._switchIsDetailsBusy(true);
		try {
			await this.AccountsHistoryDataService.getAccountsHistoryReport(
				this.selectedCardCode,
				this.dateFrom,
				this.dateTo
			);
		} catch (err) {
			this.NotificationService.error('COULD NOT LOAD ACCOUNTS HISTORY');
			console.error(err);
		} finally {
			this._switchIsDetailsBusy(false);
			this._initializeDatePicker();
		}
	}

	viewInvoices(cardCode) {
		if (cardCode) {
			this.$state.go('personal-documents', { cardCode, folder: 'Monthly Statement' });
		} else {
			this.$state.go('personal-documents');
		}
	}

	_switchIsDetailsBusy(flag) {
		this.$timeout(() => {
			this.isDetailsBusy = flag;
		});
	}

	_switchIsBusy(flag) {
		this.$timeout(() => {
			this.isBusy = flag;
		});
	}
}
